export default "__VITE_ASSET__xvY8iPN5__"